module.exports = __webpack_public_path__ + "media/bootstrap-icons/stop-btn-b545efe3.svg";